import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Segment, Header, List, Icon, Breadcrumb, Message, Button, Grid, Image, Modal, Form } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import MyMenu from '../menu';
import { get, getBlob, post } from '../../../util/api';

class TelegramIntegrations extends Component {
	state = {
		integrations: [],
		loading: true,
		error: null,
		selectedId: null,
		telegramStatus: null,
		qrImage: null,
		qrLoading: false,
		addingPhone: false,
		isMaxLimit: false,
		isConnectModalOpen: false,
		connectStep: 1,
		connectLoading: false,
		connectError: null,
		phoneNumber: '',
		phoneCode: '',
		connectedUser: null,
		targetPhoneId: null,
		isLogoutModalOpen: false,
		logoutTargetId: null,
		logoutLoading: false,
		logoutStep: 1,
		logoutError: null,
	};

	statusInterval = null;

	componentDidMount() {
		this.loadData();
	}

	componentWillUnmount() {
		if (this.statusInterval) clearInterval(this.statusInterval);
		if (this.state.qrImage) URL.revokeObjectURL(this.state.qrImage);
	}

	loadData = () => {
		const { product } = this.props;
		if (!product || !product.id) {
			this.setState({ loading: false });
			return;
		}

		this.setState({ loading: true });
		get('/telegramController/getIntegrations')
			.then((response) => {
				if (response && response.success) {
					const sortedData = _.orderBy(response.data, ['id'], ['asc']);
					this.setState({
						integrations: sortedData,
						loading: false,
					});
				} else {
					this.setState({
						loading: false,
						error: response.message || 'The data format is incorrect.',
					});
				}
			})
			.catch((err) => {
				console.error('API Hatası:', err);
				this.setState({
					loading: false,
					error: 'An error occurred while connecting to the server.',
				});
			});
	};

	handleSelectPhone = (id) => {
		if (this.state.selectedId === id) return;

		if (this.statusInterval) clearInterval(this.statusInterval);
		if (this.state.qrImage) URL.revokeObjectURL(this.state.qrImage);

		this.setState(
			{
				selectedId: id,
				telegramStatus: null,
				qrImage: null,
				qrLoading: true,
			},
			() => {
				this.checkStatus(id);
				this.statusInterval = setInterval(() => this.checkStatus(id), 6000);
			}
		);
	};

	handleAddPhone = () => {
		this.setState({ addingPhone: true });

		post('/telegramController/addTelegram', {})
			.then(async (res) => {
				const response = res.data;

				if (response && response.success) {
					// livechat konuşma listesinde Telegram filtresi için staticOptions'a yaz
					await post('/dahi/channel/save', { channel: 'live', data: { set: { staticOptions: { filter_telegram: true } } } }).catch(console.error);
					window.location.reload();
				} else {
					if (response.isMax) {
						this.setState({
							addingPhone: false,
							isMaxLimit: true,
							showMaxAlert: true,
						});
					} else {
						const msg = response ? response.message : 'Unknown error';
						alert(msg || 'The addition process failed.');
						this.setState({ addingPhone: false });
					}
				}
			})
			.catch((err) => {
				console.error('Addition Error:', err);
				alert('A communication error occurred with the server.');
				this.setState({ addingPhone: false });
			});
	};

	checkStatus = (id) => {
		get(`/telegramController/proxy/${id}/status`)
			.then((response) => {
				if (response && response.success) {
					this.setState({ telegramStatus: response.status, qrLoading: false });

					if (response.status && !response.status.loggedIn) {
						this.fetchQRCode(id);
					}
				}
			})
			.catch(() => this.setState({ qrLoading: false }));
	};

	fetchQRCode = (id) => {
		this.setState({ qrLoading: true });
		getBlob(`/telegramController/proxy/${id}/qr`)
			.then((blobData) => {
				if (blobData) {
					if (this.state.qrImage) {
						URL.revokeObjectURL(this.state.qrImage);
					}

					const imgUrl = URL.createObjectURL(blobData);

					this.setState({
						qrImage: imgUrl,
						qrLoading: false,
					});
				}
			})
			.catch((err) => {
				console.error('QR Upload Error:', err);
				this.setState({ qrLoading: false });
			});
	};

	openConnectModal = (e, id) => {
		this.setState({
			isConnectModalOpen: true,
			targetPhoneId: id,
			connectStep: 1,
			phoneNumber: '',
			phoneCode: '',
			connectError: null,
			connectLoading: false,
		});
	};

	openLogoutModal = (e, id) => {
		e.stopPropagation();
		this.setState({
			isLogoutModalOpen: true,
			logoutTargetId: id,
			logoutStep: 1,
			logoutError: null,
			logoutLoading: false,
		});
	};

	closeLogoutModal = () => {
		this.setState({ isLogoutModalOpen: false, logoutTargetId: null });
	};

	closeConnectModal = () => {
		this.setState({ isConnectModalOpen: false });
	};

	handleInputChange = (e, { name, value }) => {
		this.setState({ [name]: value, connectError: null });
	};

	handlePhoneSubmit = () => {
		const { targetPhoneId, phoneNumber } = this.state;

		if (!phoneNumber) return;

		this.setState({ connectLoading: true, connectError: null });

		post(`/telegramController/proxy/${targetPhoneId}/connectWithPhoneNumber`, { phoneNumber })
			.then((response) => {
				const res = response.data || response;

				if (res && res.success) {
					this.setState({
						connectStep: 2,
						connectLoading: false,
					});
				} else {
					this.setState({
						connectLoading: false,
						connectError: res.message || 'The phone number could not be sent.',
					});
				}
			})
			.catch((err) => {
				console.error(err);
				this.setState({
					connectLoading: false,
					connectError: 'A server error has occurred.',
				});
			});
	};

	handleCodeSubmit = () => {
		const { targetPhoneId, phoneCode } = this.state;

		if (!phoneCode) return;

		this.setState({ connectLoading: true, connectError: null });

		post(`/telegramController/proxy/${targetPhoneId}/verifyPhoneCode`, { code: phoneCode })
			.then((response) => {
				const res = response.data || response;

				if (res && res.success) {
					this.setState({
						connectStep: 3,
						connectLoading: false,
						connectedUser: res.user,
					});

					this.checkStatus(targetPhoneId);
				} else {
					this.setState({
						connectLoading: false,
						connectError: res.message || 'The code could not be verified.',
					});
				}
			})
			.catch((err) => {
				console.error(err);
				this.setState({
					connectLoading: false,
					connectError: 'A server error has occurred.',
				});
			});
	};

	handleLogoutSubmit = () => {
		const { logoutTargetId } = this.state;
		if (!logoutTargetId) return;

		this.setState({ logoutLoading: true, logoutError: null });

		post(`/telegramController/proxy/${logoutTargetId}/logout`, {})
			.then((response) => {
				const res = response.data || response;

				if (res && res.success && res.state === 'disconnected') {
					this.setState({
						logoutLoading: false,
						logoutStep: 2,
					});

					this.checkStatus(logoutTargetId);
				} else {
					this.setState({
						logoutLoading: false,
						logoutError: res.message || 'An unexpected situation occurred during the exit process.',
					});
				}
			})
			.catch((err) => {
				console.error('Logout Hatası:', err);
				this.setState({
					logoutLoading: false,
					logoutError: 'An error occurred while communicating with the server.',
				});
			});
	};

	renderConnectModal = () => {
		const { isConnectModalOpen, connectStep, connectLoading, connectError, phoneNumber, phoneCode, connectedUser } = this.state;
		const { t } = this.props;

		return (
			<Modal open={isConnectModalOpen} onClose={this.closeConnectModal} size="tiny">
				<Modal.Header>
					{connectStep === 1 && t('connectWithNumber')}
					{connectStep === 2 && t('verificationCode')}
					{connectStep === 3 && t('connectionSuccesfull')}
				</Modal.Header>
				<Modal.Content>
					{connectError && (
						<Message negative>
							<p>{connectError}</p>
						</Message>
					)}

					{connectStep === 1 && (
						<Form>
							<p>{t('enterYourNumberForTelegram')}</p>
							<Form.Input fluid placeholder="905xxxxxxxxx" name="phoneNumber" value={phoneNumber} onChange={this.handleInputChange} autoFocus />
						</Form>
					)}

					{connectStep === 2 && (
						<Form>
							<p>{t('enterCodeComingFromTelegram')}</p>
							<Form.Input
								fluid
								placeholder={t('enterSMSCode')}
								name="phoneCode"
								value={phoneCode}
								onChange={this.handleInputChange}
								maxLength="5"
								autoFocus
							/>
						</Form>
					)}

					{connectStep === 3 && connectedUser && (
						<Message positive icon>
							<Icon name="check circle" />
							<Message.Content>
								<Message.Header>{t('connectionSuccesfull')}</Message.Header>
								<p>
									{t('accountConnectedSuccessfully', {
										name: `${connectedUser?.firstName || ''} ${connectedUser?.lastName || ''}`.trim(),
										phone: connectedUser?.phone || '',
									})}
								</p>
							</Message.Content>
						</Message>
					)}
				</Modal.Content>
				<Modal.Actions>
					{connectStep !== 3 && <Button onClick={this.closeConnectModal}>{t('cancel')}</Button>}

					{connectStep === 1 && (
						<Button color="blue" onClick={this.handlePhoneSubmit} loading={connectLoading} disabled={!phoneNumber}>
							{t('continue')} <Icon name="right chevron" />
						</Button>
					)}

					{connectStep === 2 && (
						<Button color="green" onClick={this.handleCodeSubmit} loading={connectLoading} disabled={!phoneCode}>
							{t('verifyCode')} <Icon name="checkmark" />
						</Button>
					)}

					{connectStep === 3 && (
						<Button color="blue" onClick={this.closeConnectModal}>
							{t('ok')}
						</Button>
					)}
				</Modal.Actions>
			</Modal>
		);
	};

	renderLogoutModal = () => {
		const { isLogoutModalOpen, logoutStep, logoutLoading, logoutError } = this.state;
		const { t } = this.props;

		return (
			<Modal open={isLogoutModalOpen} onClose={this.closeLogoutModal} size="tiny">
				<Modal.Header>{logoutStep === 1 ? t('loguot') : t('operationSuccessful')}</Modal.Header>
				<Modal.Content>
					{logoutError && (
						<Message negative>
							<p>{logoutError}</p>
						</Message>
					)}

					{logoutStep === 1 && (
						<div style={{ textAlign: 'center', padding: '10px' }}>
							<Icon name="sign-out" size="huge" color="red" />
							<p style={{ fontSize: '1.2em', marginTop: '15px' }}>{t('telegramLogoutConfirm')}</p>
							<p style={{ color: '#666' }}>{t('telegramLogoutInfo')}</p>
						</div>
					)}

					{logoutStep === 2 && (
						<div style={{ textAlign: 'center', padding: '10px' }}>
							<Icon name="check circle" size="huge" color="green" />
							<p style={{ fontSize: '1.2em', marginTop: '15px', fontWeight: 'bold' }}>{t('logoutSuccessful')}</p>
							<p>{t('accountDisconnected')}</p>
						</div>
					)}
				</Modal.Content>
				<Modal.Actions>
					{logoutStep === 1 ? (
						<>
							<Button onClick={this.closeLogoutModal} disabled={logoutLoading}>
								{t('cancel')}
							</Button>
							<Button color="red" onClick={this.handleLogoutSubmit} loading={logoutLoading}>
								<Icon name="log out" /> {t('loguot')}
							</Button>
						</>
					) : (
						<Button color="blue" onClick={this.closeLogoutModal}>
							{t('ok')}
						</Button>
					)}
				</Modal.Actions>
			</Modal>
		);
	};

	render() {
		const { integrations, loading, error, isMaxLimit, showMaxAlert } = this.state;
		const { t } = this.props;

		const headerContent = (
			<Breadcrumb size="big">
				<Breadcrumb.Section as={Link} to={`/settings`}>
					<Icon name="setting" /> {t('settings') || 'Settings'}
				</Breadcrumb.Section>
				<Breadcrumb.Divider icon="right chevron" />
				<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
					{t('integrations') || 'Integrations'}
				</Breadcrumb.Section>
				<Breadcrumb.Divider icon="right chevron" />
				<Breadcrumb.Section>Telegram Web API</Breadcrumb.Section>
			</Breadcrumb>
		);

		if (loading) {
			return (
				<Page header={headerContent} flex>
					<MyMenu activeItem="telegram-web-api">
						<Page.Loader />
					</MyMenu>
				</Page>
			);
		}

		return (
			<Page header={headerContent} flex>
				<MyMenu activeItem="telegram-web-api">
					<Page.Wrap>
						<Grid stackable>
							<Grid.Row>
								<Grid.Column width={8}>
									{error && (
										<Message negative>
											<Message.Header>{t('Error') || 'Hata'}</Message.Header>
											<p>{error}</p>
										</Message>
									)}

									<Segment
										attached="top"
										secondary
										clearing
										style={{
											borderBottom: '1px solid #ddd',
											paddingBottom: '1rem',
										}}
									>
										<Header as="h4" style={{ margin: 0, color: '#2185d0' }}>
											{t('registiredPhones')}
										</Header>

										<Button
											color="blue"
											size="tiny"
											fluid
											onClick={this.handleAddPhone}
											loading={this.state.addingPhone}
											disabled={this.state.addingPhone}
											style={{ marginTop: '10px', paddingLeft: '12px', paddingRight: '12px' }}
										>
											{t('addNewPhone') || 'Add New Phone'}
										</Button>
									</Segment>

									<Segment attached="bottom" style={{ padding: 0 }}>
										{integrations.length > 0 ? (
											<List selection divided relaxed verticalAlign="middle" style={{ margin: 0 }}>
												{integrations.map((item) => {
													const isSelected = this.state.selectedId === item.id;

													return (
														<List.Item
															key={item.id}
															onClick={() => this.handleSelectPhone(item.id)}
															style={{
																padding: '15px',
																cursor: 'pointer',
																background: isSelected ? '#f5faff' : 'white',
																borderLeft: isSelected ? '3px solid #2185d0' : '3px solid transparent',
																transition: '0.2s',
															}}
														>
															<List.Content>
																<div
																	style={{
																		display: 'flex',
																		alignItems: 'center',
																		justifyContent: 'space-between',
																		width: '100%',
																	}}
																>
																	<div style={{ display: 'flex', alignItems: 'center' }}>
																		<Icon name="telegram" color="blue" size="large" style={{ marginRight: '10px' }} />
																		<div>
																			<Header as="h5" style={{ margin: 0, color: '#333' }}>
																				ID: {item.id}
																			</Header>
																			{item.shop && (
																				<span style={{ color: '#888', fontSize: '0.85em' }}>+{item.shop}</span>
																			)}
																		</div>
																	</div>

																	<div>
																		<Button
																			icon="phone"
																			size="mini"
																			basic
																			color="blue"
																			title={t('connectWithNumber')}
																			style={{ marginRight: '5px' }}
																			onClick={(e) => this.openConnectModal(e, item.id)}
																		/>
																		<Button
																			icon="log out"
																			size="mini"
																			basic
																			color="red"
																			title={t('logout')}
																			onClick={(e) => this.openLogoutModal(e, item.id)}
																		/>
																	</div>
																</div>
															</List.Content>
														</List.Item>
													);
												})}
											</List>
										) : (
											<Message info icon style={{ margin: '20px', boxShadow: 'none', background: 'transparent' }}>
												<Icon name="info circle" color="blue" />
												<Message.Content>
													<Message.Header>{t('noData') || 'Kayıt Bulunamadı'}</Message.Header>
													{t('noTelegramIntegration')}
												</Message.Content>
											</Message>
										)}
									</Segment>
								</Grid.Column>

								<Grid.Column width={8}>
									{!this.state.selectedId ? (
										<Segment placeholder>
											<Header icon>
												<Icon name="hand point left outline" />
												{t('choosePhoneFromLeft')}
											</Header>
										</Segment>
									) : this.state.telegramStatus?.loggedIn ? (
										<Segment placeholder color="green">
											<Header icon>
												<Icon name="check circle" color="green" />
												{t('telegramConnected')}
												{this.state.telegramStatus?.userInfo?.phone && (
													<Header.Subheader>+{this.state.telegramStatus.userInfo.phone}</Header.Subheader>
												)}
											</Header>
										</Segment>
									) : (
										<Segment textAlign="center" loading={this.state.qrLoading && !this.state.telegramStatus}>
											{this.state.qrImage ? (
												<Image src={this.state.qrImage} size="medium" centered bordered />
											) : (
												<Message info>{t('qrCodeWaiting')}</Message>
											)}
										</Segment>
									)}
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Page.Wrap>
				</MyMenu>
				{(isMaxLimit || showMaxAlert) && (
					<div
						style={{
							position: 'fixed',
							bottom: '20px',
							right: '20px',
							zIndex: 1000,
							width: '350px',
							animation: 'fadeIn 0.5s',
						}}
					>
						<Message
							warning
							floating
							icon
							onDismiss={() => this.setState({ showMaxAlert: false, isMaxLimit: false })}
							style={{ boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}
						>
							<Icon name="warning sign" />
							<Message.Content>
								<Message.Header>{t('limitReached')}</Message.Header>
								{t('maxPhoneLimitInfo')}
							</Message.Content>
						</Message>
					</div>
				)}
				{this.renderConnectModal()}
				{this.renderLogoutModal()}
			</Page>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(TelegramIntegrations));
